import { Injectable } from '@angular/core';
declare var SockJS;
declare var Stomp;
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class MessageService {

  constructor() {
    this.initializeWebSocketConnection();
  }
  public stompClient;
  public msg = [];
  
  initializeWebSocketConnection() {
    const serverUrl = environment.app_url;
    console.log(serverUrl);
    const ws = new SockJS(serverUrl);
    this.stompClient = Stomp.over(ws);
    const that = this;
    // console.log("CHEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEESE");
    // // tslint:disable-next-line:only-arrow-functions
    // this.stompClient.connect({}, function(frame) {
    //   that.stompClient.subscribe('/user/queue/chat.sendMessage', (message) => {
    //     if (message.body) {
    //       console.log(message.body);
    //       var parsedData = JSON.parse(message.body);
    //       console.log(parsedData.content);
    //       that.msg.push(parsedData.content);
    //     }
    //   });
    // });
  }

  sendMessage(message) {
    // var chatMessage = {
    //   sender: 'jayant',
    //   content: message,
    //   type: 'CHAT'
    // };
    
    // this.stompClient.send('/app/chat.sendMessage' , {}, JSON.stringify(chatMessage));
  }
}
